export enum CustomReportChannel {
  Beeswax = 'beeswax',
  Youtube = 'youtube',
  Omniplatform = 'omniplatform',
}

export default CustomReportChannel;
